import React, { useState } from 'react';
// Image imports [제거 금지]
import calendarIcon from "assets/images/icon/calendar-icon.svg";


/**
 * 3개월 기간을 계산하는 유틸리티 (Today: 2025.11.07 기준)
 */
const getInitialPeriod = (today) => {
    const endMonth = today.getMonth() + 1;
    const endYear = today.getFullYear();

    // 현재 달 포함 3개월 전
    const start = new Date(today);
    start.setMonth(start.getMonth() - 2);
    const startMonth = start.getMonth() + 1;
    const startYear = start.getFullYear();

    return {
        display: `${startYear}년 ${startMonth}월 ~ ${endYear}년 ${endMonth}월`,
    };
};

/**
 * [수정] 결제 내역 기간 선택 컴포넌트
 * 이 컴포넌트는 기간을 표시하고, 클릭 시 Bottom Sheet를 여는 역할을 합니다.
 * @param {string} periodText - PaymentHistory에서 계산된 현재 표시 기간 텍스트
 * @param {function} onSelectorClick - 기간 선택 UI를 열기 위한 버튼 클릭 핸들러
 */
function PaymentPeriodSelector({ periodText, onSelectorClick }) {
    // PaymentHistory에서 periodText를 받아 사용하므로, 내부 상태는 제거합니다.

    return (
        <div style={periodSelectorStyles.container} onClick={onSelectorClick}>
            {/* 1. 아이콘을 텍스트 앞으로 이동 */}
            <div style={periodSelectorStyles.iconWrapper}>
                <img src={calendarIcon} alt="기간 선택" style={periodSelectorStyles.icon} />
            </div>
            {/* 2. 기간 텍스트 */}
            <span style={periodSelectorStyles.periodText}>
                {periodText}
            </span>
        </div>
    );
}

const periodSelectorStyles = {
    container: {
        width: '100%',
        display: 'flex',
        // 아이콘과 텍스트를 왼쪽에서부터 배치하도록 변경
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        // 아이콘과 텍스트 사이에 간격 추가
        gap: '8px',
        // paddingTop: '32px', // PaymentHistory.jsx의 mainContent paddingTop을 받은 후, 이 컴포넌트 자체의 상단 여백을 위해 추가
    },
    periodText: {
        fontFamily: 'Pretendard',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#9A9A9A',
    },
    iconWrapper: {
        width: '24px',
        height: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        width: '80%',
        height: '80%',
    }
};

export default PaymentPeriodSelector;